import { Clerk } from "@clerk/clerk-js";


export function _createClerk() {
  return new Clerk(process.env.VITE_CLERK_PUBLISHABLE_KEY);
}

export function _load(clerk) {
  return function () {
    return clerk.load();
  };
}

export function _getSession(clerk) {
  return function() {
    return clerk.session;
  }
}

export function _getToken(session) {
  return function() {
    return session.getToken();
  }
}

export function _getUser(clerk) {
  return function() {
    return clerk.user;
  }
}

export function _getUserId(user) {
  return user.id;
}

export function _getUserName(user) {
  return `${user.firstName} ${user.lastName}`;
}

export function _getImageUrl(user) {
  return user.imageUrl;
}

export function _mountSignIn(container) {
  return function(clerk) {
    return function () {
      return clerk.mountSignIn(container);
    }
  }
}

export function _openSignIn(clerk) {
  return function () {
    return clerk.openSignIn();
  }
}

export function _openUserProfile(clerk) {
  return function () {
    return clerk.openUserProfile();
  }
}


export function _mountUserButton(container) {
  return function(clerk) {
    return function () {
      return clerk.mountUserButton(container, { showName : true });
    }
  }
}

export function _mountUserProfile(container) {
  return function(clerk) {
    return function () {
      return clerk.mountUserProfile(container);
    }
  }
}

export function _signOut(clerk) {
  return function() {
    return clerk.signOut();
  }
}

